import { render, staticRenderFns } from "./commodityMarketView.vue?vue&type=template&id=407c440f&scoped=true"
import script from "./commodityMarketView.vue?vue&type=script&lang=js"
export * from "./commodityMarketView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407c440f",
  null
  
)

export default component.exports